"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
const libs_utils_1 = require("@hotelplan/libs.utils");
// Only visualViewport can resolve virtual keyboard size issues on iOS
function useVisualViewportResize(listener, options) {
    const { enable = true, throttle: throttleTimeout, initialize = false, } = options;
    // There is not VisualViewport type within the window type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visualViewport = libs_utils_1.isBrowser
        ? window.visualViewport
        : undefined;
    (0, react_1.useEffect)(() => {
        if (!visualViewport || !enable)
            return;
        const attachedViewportListener = () => listener(visualViewport);
        const throttledListener = throttleTimeout
            ? (0, throttle_1.default)(attachedViewportListener, throttleTimeout)
            : attachedViewportListener;
        visualViewport.addEventListener('resize', throttledListener, libs_polyfills_1.optionsWithPassive);
        if (initialize) {
            attachedViewportListener();
        }
        return function cleanup() {
            visualViewport.removeEventListener('resize', throttledListener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enable, throttleTimeout]);
}
exports.default = useVisualViewportResize;
//# sourceMappingURL=useVisualViewportResize.js.map